'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/OnShelfButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnShelfButton = function (_BcReactComponent) {
  _inherits(OnShelfButton, _BcReactComponent);

  function OnShelfButton() {
    _classCallCheck(this, OnShelfButton);

    return _possibleConstructorReturn(this, (OnShelfButton.__proto__ || Object.getPrototypeOf(OnShelfButton)).apply(this, arguments));
  }

  _createClass(OnShelfButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          shelfItem = _props.shelfItem,
          intl = _props.intl,
          disabled = _props.disabled;

      var name = shelfItem.get('shelf');
      var formattedShelfName = intl.formatMessage({ id: 'label_shelf_' + name });
      var privateItem = shelfItem.get('privateItem');

      return _react2.default.createElement(
        _baseButtons.DefaultButton,
        {
          className: 'cp-on-shelf-button',
          disabled: disabled,
          handleClick: function handleClick() {
            return _this2.props.handleClick();
          },
          'aria-label': intl.formatMessage({ id: 'item_on_shelf_cta' }, { shelfName: formattedShelfName }),
          tagName: 'button',
          href: '#add-to-shelf' },
        _react2.default.createElement(
          'div',
          { className: 'shelf-button-flex-wrap' },
          _react2.default.createElement(_baseIcons.ShelfItem, { isPrivate: privateItem, onShelf: true }),
          _react2.default.createElement(
            'span',
            { className: 'shelf-name-text' },
            formattedShelfName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'cog-wrap' },
          _react2.default.createElement(_baseIcons.CogAlternate, { color: '#666', width: 14, height: 14 })
        )
      );
    }
  }]);

  return OnShelfButton;
}(_baseBcReactComponent2.default);

OnShelfButton.propTypes = {
  shelfItem: _reactImmutableProptypes2.default.map,
  handleClick: _react.PropTypes.func.isRequired,
  disabled: _react.PropTypes.bool
};

exports.default = (0, _reactIntl.injectIntl)(OnShelfButton);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-on-shelf-button/lib/components/OnShelfButton.component.js
// module id = 1496
// module chunks = 1